module.exports = __webpack_public_path__ + "img/step.f9ff5df4.svg";